import type { ChecklistItem, Faq, ProcessStep } from '../types/site';

export const fleetPoints: string[] = [
  'Semi, box truck and service body repairs',
  'Fleet color matching and commercial refinishing',
  'Include insurance or purchase-order details with your photos',
];

export const processSteps: ProcessStep[] = [
  {
    number: '01',
    title: 'Send the details',
    description: 'Share your vehicle type, damage photos and whether it rolls.',
  },
  {
    number: '02',
    title: 'Discuss the repair',
    description: 'Talk through the damage, repair scope and assessment.',
  },
  {
    number: '03',
    title: 'Plan the next step',
    description: 'Coordinate scheduling and your required return date with the shop.',
  },
];

export const faqs: Faq[] = [
  {
    question: 'What does Motor City Truck Collision do?',
    answer:
      'Motor City Truck Collision provides commercial truck collision repair, bodywork and painting in Brighton, Michigan. Work includes semi tractor cabs, box truck roofs, walls, floors and doors, fleet vehicles, service bodies, and trailer and RV exteriors.',
  },
  {
    question: 'Can I request painting without a collision repair?',
    answer:
      'Yes. Commercial truck painting, refinishing and fleet color matching are available as paint projects. Describe the surfaces you want painted, their condition and the finish you want. Include a paint code or company color standard when available.',
  },
  {
    question: 'What should I include with a quote request?',
    answer:
      'Include the vehicle type, year and model, the bodywork or painting you want, whether the vehicle can be driven, and your preferred timing. Optional photos can show the affected surfaces. An inspection may be needed to establish the work and estimate.',
  },
  {
    question: 'How long will the repair take?',
    answer:
      "Timing depends on damage, parts, repair scope and the shop's schedule. Discuss your required return date when requesting a quote.",
  },
  {
    question: 'Where is Motor City Truck Collision located?',
    answer:
      'The shop is at 12264 Emerson Dr., Brighton, MI 48116, serving Southeast Michigan. Call 248-986-8000 to discuss the vehicle, work and arrangements before bringing it in.',
  },
  {
    question: 'Do trailer and RV services include mechanical work?',
    answer:
      'These service pages describe trailer and RV body, roof and exterior work. Identify brake, axle, drivetrain or interior-system concerns separately when you call. Motor City Trailer Repair is a related service contact for trailer repair and maintenance questions; confirm the appropriate provider for each part of your project.',
  },
];

export const quoteChecklist: ChecklistItem[] = [
  { title: 'Unit type', description: 'Semi, box truck, service body, trailer or RV.' },
  { title: 'Damage photos', description: 'A few clear angles of the damaged area.' },
  { title: 'Can it be driven?', description: 'Tell us whether it drives or needs transport.' },
  { title: 'Return date', description: 'When you need the unit back in service.' },
];
